export const KEY_COOKIE = 'lt-show-how-buy-tour';
